import Component from '../inherited/Component';

export default class Video extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx);
    this._triggerElem = this._elem.querySelector('[data-video-trigger]');
    this._videoElem = this._elem.querySelector('[data-video-elem]');
  }

  async mount() {
    this._triggerElem?.addEventListener('click', (e) => {
      e.preventDefault();
      if (!this._videoElem.paused) {
        this._videoElem.pause();
      } else {
        this._videoElem.play();
      }
    });

    if (this._options.pauseOn) {
      this._triggerElem?.addEventListener(this._options.pauseOn, (e) => {
        e.preventDefault();
        this._videoElem.pause();
      });
    }

    this._videoElem.addEventListener('play', (e) => {
      this.setClasses();
      this.pauseAllOtherVideos();
    });

    this._videoElem.addEventListener('pause', (e) => {
      this.setClasses();
    });

    this.setClasses();
  }

  setClasses() {
    if (!this._videoElem.paused) {
      this._elem.classList.add('video--has-played');
      this._elem.classList.add('video--playing');
    } else {
      this._elem.classList.remove('video--playing');
    }
  }

  pauseAllOtherVideos() {
    let otherVideos = this._theme.getComponentsByType('video');
    for (let item of otherVideos) {
      if (item.elem === this._elem) continue;
      item.component._videoElem.pause();
    }
  }
}
